<template>
	<div>
		<div class="a-mask" v-if="visible" @click.stop="handleClose"></div>
		<div class="a-modal" :class="{ show: visible }" v-if="visible" :style="!hasPC ? modelStyleObj : ''">
			<img src="../../assets/close.png" alt="关闭" @click.stop="handleClose" class="close" />
			<div class="a-top">
				<div class="a-title">联系我们</div>
				<div class="a-desc">
					完善信息后，您将获得专业数字化零售顾问提供详细解答
				</div>
			</div>
			<div class="a-content">
				<a-form-model :model="formModel" :rules="rulesRef" ref="ruleForm">
					<a-form-model-item label="我想 申请试用（可多选）" class="a-form-model-item1" :colon="false"
						:label-col="labelCol" :wrapper-col="wrapperCol" prop="appCodes">
						<a-checkbox-group v-model="appCodes" class="a-checkbox">
							<span :span="8" v-for="(item, index) in appCodesList" :key="index">
								<a-checkbox :value="item.appCode">
									{{ item.appDesc }}
								</a-checkbox>
							</span>
						</a-checkbox-group>
					</a-form-model-item>
					<a-form-model-item :label-col="labelCol1" :wrapper-col="wrapperCol1" label="姓名" :colon="false"
						prop="name">
						<a-input placeholder="请输入姓名" :maxLength="11" autocomplete="off" v-model="formModel.name" />
					</a-form-model-item>
					<a-form-model-item :colon="false" :label-col="labelCol1" label="手机号码" :wrapper-col="wrapperCol1"
						prop="phone">
						<a-input placeholder="请输入手机号码" autocomplete="off" v-model="formModel.phone" :maxLength="11" />
					</a-form-model-item>
					<a-form-model-item :colon="false" :label-col="labelCol1" label="公司名称" :wrapper-col="wrapperCol1"
						prop="companyName">
						<a-input placeholder="请输入公司名称" autocomplete="off" :maxLength="11"
							v-model="formModel.companyName" />
					</a-form-model-item>
					<a-form-model-item :label-col="labelCol1" :wrapper-col="wrapperCol1" label="验证码" :colon="false"
						prop="captcha">
						<a-input placeholder="请输入验证码" autocomplete="off" class="a-input-left"
							:style="!hasPC ? aInputLeftObj : ''" :maxLength="4" :mixLength="4"
							v-model="formModel.captcha" @keyup.enter="submit" />
						<div type="primary" class="a-input-code" v-throttle="
                () => {
                  getVerification();
                }
              ">
							<img :src="randCodeImage" title="点击刷新验证码" />
						</div>
					</a-form-model-item>
					<a-button type="primary" class="submit" v-throttle="
              () => {
                submit();
              }
            ">立即提交</a-button>
					<!--  <div class="footer">
            注：若遇到提交问题，请拨打电话 周先生 18924635410
          </div> -->
				</a-form-model>
			</div>
		</div>
	</div>
</template>
<script>
	let wih = window.document.documentElement.getBoundingClientRect().width;
	let hit = window.document.documentElement.getBoundingClientRect().height;
	export default {
		name: "loginModel",
		data() {
			return {
				appCodes: ["TC10"],
				modelStyleObj: {
					width: wih - 10 + "px",
					height: hit - 40 + "px",
					overflow: "scroll",
				},
				aInputLeftObj: {
					width: "145px",
				},
				currdatetime: "", //时间搓
				randCodeImage: "", //验证码
				ModalText: "联系我们",
				visible: false,
				appCodesList: [{
						appCode: "TC10",
						appDesc: "Weiit数字门店",
						appIcon: null,
						appName: "Weiit数字门店",
						appUrl: "https://store.tikcos.cn/auth?appCode=TC10&ticket=#rcsToken#&companyCode=#companyCode#",
						createBy: null,
						createTime: null,
						createUserId: null,
						delFlag: "0",
						id: "TC10",
						salePrice: 100,
						sort: "2",
						state: "1",
						updateBy: "admin",
						updateTime: "2021-07-28",
						updateUserId: null,
					},
					{
						appCode: "TC20",
						appDesc: "Weiit数字商城",
						appIcon: null,
						appName: "Weiit数字商城",
						appUrl: "https://mall.tikcos.cn/auth?appCode=TC20&ticket=#rcsToken#&companyCode=#companyCode#",
						createBy: null,
						createTime: null,
						createUserId: null,
						delFlag: "0",
						id: "TC20",
						salePrice: 100,
						sort: "3",
						state: "1",
						updateBy: "admin",
						updateTime: "2021-08-06",
						updateUserId: null,
					},
					{
						appCode: "TC30",
						appDesc: "Weiit数字会员",
						appIcon: null,
						appName: "私域",
						appUrl: "https://www.tikcos.cn",
						createBy: null,
						createTime: null,
						createUserId: null,
						delFlag: "0",
						id: "TC30",
						salePrice: 100,
						sort: "4",
						state: "1",
						updateBy: "admin",
						updateTime: "2021-08-06",
						updateUserId: null,
					},
				],
				formModel: {
					appCodes: "",
					name: "",
					phone: "",
					companyName: "",
					captcha: "",
				},
				rulesRef: {
					appCodes: [{
						required: true,
						message: "请选中需要试用的门店！",
						trigger: "blur",
					}, ],
					name: [{
						required: true,
						message: "请输入姓名！",
						trigger: "blur",
					}, ],
					phone: [{
							required: true,
							message: "请输入手机号码！",
							trigger: "blur",
						},
						{
							validator: this.handlePhoneCheck,
						},
					],
					companyName: [{
						required: true,
						message: "请输入公司名称！",
						trigger: "blur",
					}, ],
					captcha: [{
						required: true,
						message: "请输入验证码！",
						trigger: "blur",
					}, ],
				},
				labelCol1: {
					span: 5,
				},
				wrapperCol1: {
					span: 19,
				},
				labelCol: {
					span: 24,
				},
				wrapperCol: {
					span: 24,
				},
			};
		},
		inject: ["hasPC"],
		watch: {
			visible: {
				handler(n, o) {
					if (n) {
						this.getVerification();
					}
				},
			},
			appCodes: {
				handler(newVal, oldVal) {
					if (newVal !== undefined) {
						let list = [];
						this.appCodesList.forEach((s, b) => {
							newVal.forEach((e, i) => {
								if (s.appCode == e) {
									list.push(s.appName);
								}
							});
						});
						this.formModel.appCodes = newVal.join(",");
						this.formModel.appCodesDict = list.join(",");
					}
				},
				deep: true,
				immediate: true,
			},
		},
		methods: {
			handlePhoneCheck(rule, value, callback) {
				var reg = /^1[3456789]\d{9}$/;
				if (!reg.test(value)) {
					callback(new Error("请输入正确的手机号码"));
				} else {
					callback();
				}
			},
			handleClose() {
				this.visible = false;
				this.formModel = {
					appCodes: "",
					name: "",
					phone: "",
					companyName: "",
					captcha: "",
				};
				this.appCodes = ["TC10"];
			},
			getVerification() {
				this.currdatetime = new Date().getTime();
				this.$axios
					.get(`${this.$api.randomImage}/${this.currdatetime}`)
					.then(({
						success,
						result,
						message
					}) => {
						if (success) {
							this.randCodeImage = result;
						} else {
							this.$message.error(message);
						}
					});
			},
			submit() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						let data = Object.assign(this.formModel, {
							checkKey: this.currdatetime,
						});
						this.$axios
							.post(this.$api.addApplyForTrial, data)
							.then(({
								success,
								result,
								message
							}) => {
								if (success) {
									this.$message.success("提交成功！");
									this.visible = false;
								} else {
									this.getVerification();
								}
							});
					}
				});
			},
			//提交
			getAppInfo() {
				this.$axios
					.post(this.$api.getAppInfo)
					.then(({
						success,
						result,
						message
					}) => {
						if (success) {
							this.appCodesList = result;
						} else {
							this.$message.error(message);
						}
					});
			},
			//获取验证码
		},
	};
</script>
<style lang="scss" scoped>
	@keyframes mymove {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.a-mask {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 1000;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.45);
	}

	.a-modal {
		.close {
			width: 28px;
			height: 28px;
			cursor: pointer;
			position: absolute;
			right: 10px;
			top: 10px;
		}

		position: absolute;
		z-index: 1000;
		background-color: #ffffff;
		transform: translate(-50%, -50%);
		top: 46%;
		left: 50%;
		border-radius: 8px;
		width: px(627);
		height: px(670);
		padding: px(24) px(47) px(28) px(47);
		box-shadow:0 0 16px rgba(31, 84, 167, 0.1);

		.opacity {
			opacity: 0.5;
		}

		&.show {
			opacity: 1;
			animation: mymove 0.8s;
		}

		.a-top {
			padding-bottom: px(27);
			border-bottom: px(1) solid #cacaca;

			.a-title {
				line-height: 1;
				margin-bottom: px(18);
				font-size: px(26);
				font-family: Source Han Sans CN;
				font-weight: bold;
				text-align: left;
				color: #111111;
				display: flex;
				justify-content: space-between;
			}

			.a-desc {
				font-size: px(16);
				font-family: Source Han Sans CN;
				font-weight: 400;
				text-align: left;
				color: #111111;
			}
		}

		::v-deep .ant-form-item-control {
			flex-direction: row;
		}

		.a-content {

			::v-deep .ant-form-item-explain-error,
			::v-deep .ant-form-item-extra,
			::v-deep .ant-form-item-explain {
				font-size: px(16);
				transition: none;
				color: #ff4d4f;
				text-align: left !important;
				position: absolute;
				bottom: px(-27);
			}

			.ant-form {
				::v-deep .ant-form-item {
					margin-bottom: 0;
					font-size: px(12);
					margin-bottom: px(30);
				}

				::v-deep .ant-form-item-control {
					width: px(172) !important;
					margin-right: px(10);
					max-width: 100% !important;
					// display: flex;
					// align-items: center;
					text-overflow: ellipsis;
					text-align: left;
				}

				::v-deep .ant-form-item-required {
					&::before {
						font-size: px(14);
						margin-right: px(11);
					}
				}

				::v-deep .ant-form-item-label {
					max-width: 100% !important;
					text-overflow: ellipsis;
					text-align: left;
				}

				::v-deep .ant-form-item-label>label {
					height: px(48);
					font-size: px(16);
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #111111;
				}

				::v-deep .ant-form-item-control-input {
					min-height: initial;
				}

				::v-deep .ant-form-item-control {
					width: px(600) !important;

					.ant-form-item-children {
						display: flex;
						max-width: 100% !important;
					}
				}

				::v-deep .ant-form-item-control-input-content {
					display: flex;
				}

				.a-form-model-item1 {
					::v-deep .ant-form-item-label {
						width: px(200) !important;
					}

					::v-deep .ant-form-item-no-colon {
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #111111;
						font-size: px(16);
						margin: px(15) 0 px(15) 0;
					}

					margin: px(20) px(0) px(30) px(0);
				}

				.ant-input {
					width: px(574);
					height: px(48);
					font-size: px(16);
					padding-left: px(17);

					&.a-input-left {
						width: px(384);
						margin-right: px(11);
					}
				}

				.a-input-code {
					width: px(150);
					height: px(48);
					padding: 4px 0px;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.a-input-refresh {
					cursor: pointer;
					height: px(48);
					display: flex;
					align-items: center;

					span {
						font-size: px(16);
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #072afa;
						line-height: 100%;

						&:nth-last-child(1) {
							width: px(26);
							height: px(26);
							margin-left: px(16);
							border-radius: 50%;

							img {
								object-fit: fill;
								width: 100%;
								height: 100%;
							}
						}
					}
				}

				.a-input-right {
					width: px(110);
					height: px(48);
					display: flex;
					font-size: px(16);
					justify-content: center;
					align-items: center;

					&.ant-btn {
						background: #072afa;
					}

					img {
						width: 100%;
						height: 100%;
					}
				}

				.submit {
					cursor: pointer;
					font-size: px(16);
					width: 100%;
					height: px(65);
					background: #072afa;
				}

				.footer {
					margin-top: px(20);
					font-size: px(16);
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #999999;
					text-align: left;
				}

				::v-deep .ant-checkbox-wrapper {
					margin-right: px(16);
					font-size: px(16);
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #111111;

					.ant-checkbox {
						margin-right: px(2);

						.ant-checkbox-input,
						.ant-checkbox-inner {
							width: px(16);
							height: px(16);
						}
					}
				}
			}
		}
	}
</style>